import { TopProductProperties } from './top-product-properties'

export default TopProductProperties
